import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LandingPageService } from '../../../services/landing-page.service';
import { Globals } from '../../../globals';
import { MessagingService } from '../../../services/messaging.service';
import { LOCID } from '../../../constants';
import { PatientCaseViewDataModel } from '../../../models/patient/patient-case-view-data.model';
import { UiService } from '../../../services/ui.service';
import { Subscription } from 'rxjs';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { TdoNoteQueryModel } from '../../controls/tdo-notes/models/tdo-note-query.model';
import { NotesService } from '../../../services/notes.service';
import { SignalrService } from '../../../services/socket/signalr.service';
import { StaticDataService } from "../../../services/static-data.service";
import { EnumValidValueItemModel } from "../../../models/enum/enum-valid-value-item.model";
import { DialogService } from "../../../services/dialog.service";
import { CaseService } from "../../../services/case.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { CaseEditDialogComponent } from "../../../dialog/case-edit-dialog/case-edit-dialog.component";
import { AuthenticationService } from 'src/app/modules/auth/services/authentication.service';

@Component({
  standalone: false,
  selector: 'app-home-cases-view',
  templateUrl: './home-cases-view.component.html',
  styleUrls: ['./home-cases-view.component.scss']
})
export class HomeCasesViewComponent implements OnInit, OnDestroy {
  @ViewChild('caseList') caseList: ElementRef;

  @Input() isExpanded: boolean = false;

  patientCaseList: PatientCaseViewDataModel[];
  selectedCaseItem: PatientCaseViewDataModel;
  lastCaseItem: PatientCaseViewDataModel;
  locid: number = 0;
  msgSub: Subscription;
  validValueSubscription: Subscription;
  getPatientsSubscription: Subscription;
  caseStatusEnums: EnumValidValueItemModel[] = [];
  isAllExpanded = false;
  loadingCases = false;
  processedRefresh = false;
  refreshTimeout: any;

  constructor(private readonly landingPageService: LandingPageService,
    private readonly caseService: CaseService,
    private readonly globals: Globals,
    private readonly notesService: NotesService,
    private readonly signalrService: SignalrService,
    private readonly staticDataService: StaticDataService,
    private readonly dialogService: DialogService,
    private readonly dialog: MatDialog,
    private readonly authenticationService: AuthenticationService,
    private readonly messagingService: MessagingService,
    private readonly uiService: UiService,
    private readonly cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (!this.authenticationService.isLoggedIn()) {
      // console.log('home cases view init not logged in');
      return;
    }
    if (localStorage.getItem(LOCID)) {
      this.locid = parseInt(localStorage.getItem(LOCID));
    }
    if (this.staticDataService.isReady) {
      this.setupEnums();
    }
    else if (!this.validValueSubscription) {
      this.validValueSubscription = this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
      // console.log('HomeCasesViewComponent ngOnInit refreshValues');
      this.staticDataService.refreshValues(true, false, false);
    }


    this.msgSub = this.messagingService.componentMessageCall.subscribe(response => {
      this.ProcessComponentMessage(response);
    });

    this.signalrService.messageUser.subscribe((res) => {
      // console.log('HomeCasesViewComponent signalr messageUser');
      switch (res.messageType) {
        case SignalrService.UPDATE_TEETH:
        case MessagingConstants.CASES_REFRESH:
          if (this.processedRefresh) {
            // console.log('HomeCasesViewComponent signalr CASES_REFRESH processedRefresh true');
            return;
          }
          this.processedRefresh = true;
          // console.log("signalr ProcessedRefresh set to true");
          this.refreshTimeout = setTimeout(() => {
            this.processedRefresh = false;
            // console.log("signalr  ProcessedRefresh set to false");
          }, 10000);
          if (res.message && res.message['patientId'] && res.message['patientId'] === this.globals.currentPatientId) {
            this.loadingCases = true;
            this.getPatientsSubscription = this.landingPageService.getPatientsCases4Landing(this.globals.currentPatientId).subscribe((data) => {
              const patientCaseId = res.message['PatientCaseId'] || this.selectedCaseItem?.PatientCaseId;
              setTimeout(() => {
                this.loadingCases = false;
                this.patientCaseList = data;
                this.selectedCaseItem = this.patientCaseList.find(p => p.PatientCaseId === patientCaseId);
                this.scrollToBottom();
                if (this.selectedCaseItem && res.messageType === MessagingConstants.CASES_REFRESH) {
                  // console.log('HomeCasesViewComponent signalr CASES_REFRESH onCaseItemClick');
                  this.onCaseItemClick(null, this.selectedCaseItem);
                }
                this.cdr.markForCheck();
              }, 0);
            },
            error => {
              setTimeout(() => {
                this.loadingCases = false;
                this.cdr.markForCheck();
              }, 0);
              console.error(error);
            });
          }
          break;
      }
    });

    this.initCases();
  }

  setupEnums() {
    this.caseStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseStatus');
  }

  isItemSelected(model: PatientCaseViewDataModel) {
    return this.selectedCaseItem === model;
  }

  onCaseItemClick(event: MouseEvent | null, model: PatientCaseViewDataModel) {
    // console.log('HomeCasesViewComponent onCaseItemClick model', model);
    // console.log('HomeCasesViewComponent onCaseItemClick this.lastCaseItem', this.lastCaseItem);
    if (event && event instanceof MouseEvent) {
      localStorage.setItem('isSelectedMTI', 'false');
    }

    // console.log('HomeCasesViewComponent onCaseItemClick model !== this.lastCaseItem', model != this.lastCaseItem);
    if (model != this.lastCaseItem) {

      localStorage.setItem('SelectedCaseDescription', `${model.Description} ${this.getTeeth(model.TeethList)} ${model.DateString}`);
      this.selectedCaseItem = model;
      this.uiService.selectedCaseItem = this.selectedCaseItem;
      this.globals.currentPatientCaseId = this.selectedCaseItem.PatientCaseId;
      this.globals.currentParentPatientCaseId = this.selectedCaseItem.Case.ParentPatientCaseId;
      // console.log('HomeCasesViewComponent onCaseItemClick this.globals.currentPatientCaseId', this.globals.currentPatientCaseId);
      // console.log('HomeCasesViewComponent onCaseItemClick this.globals.currentParentPatientCaseId', this.globals.currentParentPatientCaseId);
      if (localStorage.getItem('isSelectedMTI') !== 'true') {
        this.globals.currentPatientCaseWorkItemID = null;
      }
      this.globals.currentPatientCaseWorkItemFormsID = null;
      this.globals.save();

      this.messagingService.sendComponentMessage(MessagingConstants.CASE_CHANGED_EVENT, this.selectedCaseItem);

      const noteQueryModel = new TdoNoteQueryModel();
      noteQueryModel.parentObjectName = 'dataPatientCase';
      noteQueryModel.objectId = this.selectedCaseItem.PatientCaseId;
      noteQueryModel.patientId = this.globals.currentPatientId;
      this.notesService.changeNoteQuery(noteQueryModel);
      this.lastCaseItem = this.selectedCaseItem;
    }
  }

  private findCaseInList(caseId: string): PatientCaseViewDataModel {
    let found = this.patientCaseList.find(p => p.PatientCaseId === caseId);
    if (!found) {
      const parent = this.patientCaseList.find(p => p.Case.ChildCases.length > 0 && p.Case.ChildCases.some(c => c.PatientCaseId === caseId));
      if (parent) {
        parent.isExpanded = true;
        found = parent.Case.ChildCases.find(c => c.PatientCaseId === caseId);
      }
    }
    return found;
  }

  private initCases(): void {
    this.patientCaseList = [];

    // console.log('HomeCasesViewComponent initCases globals.currentPatientId', this.globals.currentPatientId);

    if (this.globals.currentPatientId) {
      this.loadingCases = true;
      this.getPatientsSubscription = this.landingPageService.getPatientsCases4Landing(this.globals.currentPatientId).subscribe((data) => {
        const runUpdate = () => {
          this.loadingCases = false;
          this.patientCaseList = data;
          this.scrollToBottom();
          // console.log('HomeCasesViewComponent initCases from getPatientsCases4Landing patientCaseList', this.patientCaseList);
          if (this.patientCaseList.length === 0) {
            this.globals.currentPatientSelectedCaseItem = {};
            this.globals.currentPatientCaseId = null;
            this.globals.currentParentPatientCaseId = null;
            this.globals.save();
            this.messagingService.sendComponentMessage(MessagingConstants.CASE_CHANGED_EVENT, null);
          } else {
            let previousSelectedCaseItem = this.findCaseInList(this.globals.currentPatientCaseId);
            if (!previousSelectedCaseItem) {
              previousSelectedCaseItem = this.patientCaseList[this.patientCaseList.length - 1];
            }

            this.selectedCaseItem = previousSelectedCaseItem;
            this.uiService.selectedCaseItem = this.selectedCaseItem;
            this.globals.currentPatientSelectedCaseItem = this.selectedCaseItem;
            this.globals.currentPatientCaseId = this.selectedCaseItem.PatientCaseId;
            this.globals.currentParentPatientCaseId = this.selectedCaseItem.Case.ParentPatientCaseId;
            this.globals.save();

            this.messagingService.sendComponentMessage(MessagingConstants.CASE_CHANGED_EVENT, this.selectedCaseItem);

            const noteQueryModel = new TdoNoteQueryModel();
            noteQueryModel.parentObjectName = 'dataPatientCase';
            noteQueryModel.objectId = this.selectedCaseItem.PatientCaseId;
            noteQueryModel.patientId = this.globals.currentPatientId;
            this.notesService.changeNoteQuery(noteQueryModel);

            this.lastCaseItem = this.selectedCaseItem;
          }
          this.cdr.markForCheck();
        };
        setTimeout(runUpdate, 0);
      },
        error => {
          console.error(error);
          this.uiService.displayMessage('Error', 'Failed to get cases: ' + (error.statusText ?? error.error.ExceptionMessage));
          setTimeout(() => {
            this.loadingCases = false;
            this.cdr.markForCheck();
          }, 0);
        });
    }
  }
  scrollToBottom() {
    const ivl = setInterval(() => {
      if (!this.caseList) {
        return;
      }
      clearInterval(ivl);
      this.caseList.nativeElement.scrollTop = this.caseList.nativeElement.scrollHeight;
    }, 100);
  }


getTeeth(teeth: string[]) {
  if (!teeth || teeth.length === 0) {
    return '';
  } else if (teeth.length <= 3) {
    let str = '';
    for (let i = 0; i < teeth.length; i++) {
      if (i !== teeth.length - 1) {
        str += teeth[i] + ', ';
      } else {
        str += teeth[i];
      }
    }
    return '# ' + str;
  } else {
    const sub = teeth[0].toString() + ', ' + teeth[1].toString() + ', ' + teeth[2].toString() + '...';
    return '# ' + sub;
  }
}

getStatus(enumCaseStatusID: string) {
  if (this.caseStatusEnums) {
    if (enumCaseStatusID) {
      const enu = this.caseStatusEnums.find(p => p.ValidValueItemId.toLowerCase() === enumCaseStatusID.toLowerCase());
      if (enu) {
        return enu.ItemDisplayValue;
      } else {
        return this.caseStatusEnums[0]?.ItemDisplayValue;
      }
    } else {
      return this.caseStatusEnums[0]?.ItemDisplayValue;
    }
  }
}

getStatusImage(enumCaseStatusID: string) {
  if (this.caseStatusEnums) {
    if (enumCaseStatusID) {
      const enu = this.caseStatusEnums.find(p => p.ValidValueItemId.toLowerCase() === enumCaseStatusID.toLowerCase());
      if (enu) {
        return enu.IconIDSVG;
      } else {
        return this.caseStatusEnums[0]?.IconIDSVG;
      }
    } else {
      return this.caseStatusEnums[0]?.IconIDSVG;
    }
  }
}

addNewCase() {
  const config = new MatDialogConfig();
  config.data = { caseItem: null, mode: 'newCase' };
  config.panelClass = 'dialog';
  config.disableClose = true;

  this.dialog.open(CaseEditDialogComponent, config).afterClosed().subscribe((res) => {
    if (res) {
      this.initCases();
    }
  });
}

addChildCase() {
  const config = new MatDialogConfig();
  config.data = { caseItem: this.selectedCaseItem, mode: 'newChildCase', allCases: this.patientCaseList };
  config.panelClass = 'dialog';
  config.disableClose = true;
  config.height = '535px';

  this.dialog.open(CaseEditDialogComponent, config).afterClosed().subscribe((res) => {
    if (res) {
      this.initCases();
    }
  });
}

editCase() {
  const config = new MatDialogConfig();
  config.data = { caseItem: this.selectedCaseItem, mode: 'editCase', allCases: this.patientCaseList };
  config.panelClass = 'dialog';
  config.disableClose = true;

  this.dialog.open(CaseEditDialogComponent, config).afterClosed().subscribe((res) => {
    if (res) {
      this.messagingService.sendComponentMessage(MessagingConstants.LEDGER_REFRESH, {});
      this.messagingService.sendComponentMessage(MessagingConstants.FEES_PAGE_REFRESH, {});
      this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, this.selectedCaseItem?.PatientCaseId);
    }
  });
}

deleteCase() {
  this.dialogService.openConfirmDialog('Are you sure you want to delete ' + this.selectedCaseItem.Description + ' ' + this.selectedCaseItem.DateString + '?').subscribe((res) => {
    if (res) {
      this.caseService.deleteCase(this.selectedCaseItem.PatientCaseId).subscribe(() => {
        const idx = this.patientCaseList.findIndex(p => p.PatientCaseId.toLowerCase() === this.selectedCaseItem.PatientCaseId.toLowerCase());
        if (idx > -1) {
          this.patientCaseList.splice(idx, 1);
          if (this.patientCaseList.length > 0) {
            this.selectedCaseItem = this.patientCaseList[0];
          }
        }
      });
    }
  });
}

expandAll() {
  this.isAllExpanded = true;
  for (const cse of this.patientCaseList) {
    cse.isExpanded = true;
  }
}

collapseAll() {
  this.isAllExpanded = false;
  for (const cse of this.patientCaseList) {
    cse.isExpanded = false;
  }
}

ProcessComponentMessage(response) {
  // console.log('HomeCasesViewComponent ProcessComponentMessage: ', response);
  if (response.event === MessagingConstants.PATIENT_LOADED) {
    this.initCases();
  }
  else if (response.event === MessagingConstants.PENDING_CASES_REFRESH_LIST_ONLY) {
    // console.log('HomeCasesViewComponent ProcessComponentMessage PENDING_CASES_REFRESH_LIST_ONLY');
    this.processedRefresh = true;
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
      this.refreshTimeout = null;
    }
    this.refreshTimeout = setTimeout(() => {
      this.processedRefresh = false;
      // console.log("Component ProcessedRefresh set to false");
    }, 60000);
  }
  else if (response.event === MessagingConstants.CASES_REFRESH_SELECT_CASE) {
    // console.log('HomeCasesViewComponent ProcessComponentMessage CASES_REFRESH_SELECT_CASE');
    this.loadingCases = true;
    this.getPatientsSubscription = this.landingPageService.getPatientsCases4Landing(this.globals.currentPatientId).subscribe((data) => {
      setTimeout(() => {
        this.loadingCases = false;
        this.patientCaseList = data;
        this.selectedCaseItem = this.patientCaseList.find(p => p.PatientCaseId === response.data.parentCaseId);
        this.scrollToBottom();
        if (this.selectedCaseItem) {
          if (this.selectedCaseItem.Case.ChildCases.length > 0) {
            this.selectedCaseItem.isExpanded = true;
            this.selectedCaseItem = this.selectedCaseItem.Case.ChildCases[0];
          }
          this.lastCaseItem = null;
          // console.log('HomeCasesViewComponent ProcessComponentMessage CASES_REFRESH_SELECT_CASE onCaseItemClick');
          this.onCaseItemClick(null, this.selectedCaseItem);
        }
        this.cdr.markForCheck();
      }, 0);
    },
      error => {
        console.error(error);
        setTimeout(() => {
          this.loadingCases = false;
          this.cdr.markForCheck();
        }, 0);
      });
  }
  else if (response.event === MessagingConstants.CASES_REFRESH || response.event === MessagingConstants.CASES_REFRESH_LIST_ONLY) {
    // console.log('HomeCasesViewComponent ProcessComponentMessage CASES_REFRESH or CASES_REFRESH_LIST_ONLY', response);
    this.processedRefresh = true;
    // console.log("Component ProcessedRefresh set to true");
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
      this.refreshTimeout = null;
    }
    this.refreshTimeout = setTimeout(() => {
      this.processedRefresh = false;
      // console.log("Component ProcessedRefresh set to false");
    }, 10000);
    setTimeout(() => {
      this.patientCaseList = [];
      this.loadingCases = true;
      this.cdr.markForCheck();
      this.getPatientsSubscription = this.landingPageService.getPatientsCases4Landing(this.globals.currentPatientId).subscribe((data) => {
      setTimeout(() => {
        this.patientCaseList = data;
        if (response.event === MessagingConstants.CASES_REFRESH) {
          this.selectedCaseItem = this.patientCaseList.find(p => p.PatientCaseId === response.data);

          if (this.selectedCaseItem) {
            // console.log('HomeCasesViewComponent ProcessComponentMessage CASES_REFRESH onCaseItemClick');
            this.onCaseItemClick(null, this.selectedCaseItem);
          }
          this.scrollToBottom();
        }
        else {
          let toothChanged = false;
          if (this.selectedCaseItem) {
            const newCase = this.findCaseInList(this.selectedCaseItem.PatientCaseId);
            if (newCase?.TeethList && this.selectedCaseItem.TeethList) {
              const oldTeeth = this.selectedCaseItem.TeethList;
              const newTeeth = newCase.TeethList;
              toothChanged = oldTeeth.length !== newTeeth.length
                || oldTeeth.some(t => !newTeeth.includes(t))
                || newTeeth.some(t => !oldTeeth.includes(t));
            }
            if (newCase) {
              this.selectedCaseItem = newCase;
              this.uiService.selectedCaseItem = this.selectedCaseItem;
            }
            if (toothChanged && !response.data?.skipCaseChangedEvent) {
              this.messagingService.sendComponentMessage(MessagingConstants.CASE_CHANGED_EVENT, this.selectedCaseItem);
            }
          }
        }
        this.loadingCases = false;
        this.cdr.markForCheck();
      }, 0);
    },
      error => {
        console.error(error);
        this.uiService.displayMessage('Error', 'Failed to refresh cases.');
        setTimeout(() => {
          this.loadingCases = false;
          this.cdr.markForCheck();
        }, 0);
      });
    }, 0);
  }
  else if (response.event === MessagingConstants.ONLY_CASES_STATUS_REFRESH) {
    if (response.data.PatientCaseId) {
      this.getPatientsSubscription = this.caseService.getPatientCaseById(response.data.PatientCaseId).subscribe((data) => {
        this.selectedCaseItem = this.patientCaseList.find(p => p.PatientCaseId === response.data.PatientCaseId);
        this.selectedCaseItem.Case.enumCaseStatusID = data.enumCaseStatusID;
        this.scrollToBottom();
      });
    }
  }
}
ngOnDestroy() {
  if (this.validValueSubscription)
    this.validValueSubscription.unsubscribe();
  if (this.msgSub)
    this.msgSub.unsubscribe();
  if (this.getPatientsSubscription)
    this.getPatientsSubscription.unsubscribe();
}
}
